import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        //server vars
        pageSetup: null,
        indexPage: null,
        aboutPage: null,
        paymentPage: null,
        questionsPage: null,
        contactsPage: null,
        dataPolicyPage: null,
        favoritePage: null,
        favoriteLocalStorageUpdate: false,
        formsData: null,
        formsModalGlobalParam: 'call',
        formModalContainerInit: false,
        formsModalGlobalData: {
            page: null,
            block: null,
        },
        formsModalRealEstate: {
            project: null,
            id: null,
            part: null,
            rooms: null,
            size: null,
            price: null,
            link: null,
        },
        // News Items
        newsItemsPromo: null,
        newsItems: null,
        newsPaginTotalPage: 1,
        newsPaginCurPage: 1,
        //Sales Items
        salesItems: null,
        salesItemsDefault: null,
        salesItemsAnimate: true,
        // project vars
        isOpenSendwich: false,
        isOpenFormConsult: false,
        isMobileChecker: false,
        isVisibleOnScrollEvent: true,
        isHeaderBGonScrollEvent: false,
        isSalesCardVideoModalOpen: false,
        salesCardVideoModalData: null,
        //
        //
        // FILTERS PARAMS FROM CMS
        filterCMSparams: null,
        //--//--//--//--// SALES FILTER DATA sales filter main page and sales page
        filterSales_Data: {
            initRangeSliders: false,
            location_type: 'district',
            segment_type: 'all',
            disctrictChecked: [],
            metroChecked: [],
            roomQuantities: [],
            size: [],
            floor: [],
            price: [],
            finish: 'not',
            actions: false,
            availableForSale: true,
            filter_items_count: 0,
            unAvailableForSaleReset: false,
        },
        openMobileFilter: false,
        //--//--/END/--//--// SALES FILTER DATA
        //--//--//--//--// PARKING FILTER DATA
        filterParking_Data: {
            // vars
            initRangeSliders: false,
            filter_items_count: 0,
            // data
            complexChecked: [],
            partsChecked: [],
            classChecked: [],
            levelQuantities: [],
            size: [],
            price: [],
            electro: false,
            actions: false,
        },
        parkingItems: null,
        parkingItemsDefault: null,
        parkingItemsAnimate: true,
        parkingListView: 'grid',
        openParkingMobileFilter: false,
        openParkingMobileShorting: false,
        parking_shorting_param: null,
        //--//--/END/--//--// PARKING FILTER DATA
        //--//--//--//--// STOREROOMS FILTER DATA
        filterStoreRooms_Data: {
            // vars
            initRangeSliders: false,
            filter_items_count: 0,
            // data
            complexChecked: [],
            partsChecked: [],
            classChecked: [],
            levelQuantities: [],
            size: [],
            price: [],
            actions: false,
        },
        storeRoomsItems: null,
        storeRoomsItemsDefault: null,
        storeRoomsItemsAnimate: true,
        storeRoomsListView: 'grid',
        openStoreRoomsMobileFilter: false,
        openStoreRoomsMobileShorting: false,
        storeRooms_shorting_param: null,
        //--//--/END/--//--// STOREROOMS FILTER DATA
        //--//--//--//--// COMMERCE FILTER DATA
        filterCommerce_Data: {
            // vars
            initRangeSliders: false,
            filter_items_count: 0,
            // data
            complexChecked: [],
            partsChecked: [],
            classChecked: [],
            levelQuantities: [],
            level: [],
            size: [],
            price: [],
            actions: false,
        },
        commerceItems: null,
        commerceItemsDefault: null,
        commerceItemsAnimate: true,
        openCommerceMobileFilter: false,
        commerceListView: 'grid',
        openCommerceMobileShorting: false,
        commerce_shorting_param: null,
        //--//--/END/--//--// COMMERCE FILTER DATA
        //--//--//--//--// FLATS FILTER DATA
        filterFlats_Data: {
            // vars
            initRangeSliders: false,
            filter_items_count: 0,
            // data
            segment_type: 'all',
            complexChecked: [],
            partsChecked: [],
            roomsQuantities: [],
            size: [],
            floor: [],
            price: [],
            actions: false,
        },
        flatsItems: null,
        flatsItemsDefault: null,
        flatsItemsAnimate: true,
        openFlatsMobileFilter: false,
        flatsListView: 'grid',
        openFlatsMobileShorting: false,
        flats_shorting_param: null,
        flatsResizeElem: false,
        flatsResizeImg: null,
        //--//--/END/--//--// FLATS FILTER DATA
    },
    getters: {
        // Pages
        loadPageSetUp: state => state.pageSetup,
        loadIndexPage: state => state.indexPage,
        loadAboutPage: state => state.aboutPage,
        loadPaymentPage: state => state.paymentPage,
        loadQuestionsPage: state => state.questionsPage,
        loadContactsPage: state => state.contactsPage,
        loadDataPolicyPage: state => state.dataPolicyPage,
        loadFavoritePage: state => state.favoritePage,
        loadFavoriteLocalStorageUpdate: state => state.favoriteLocalStorageUpdate,
        loadFormsData: state => state.formsData,
        loadFormsGlobalParam: state => state.formsModalGlobalParam,
        loadFormsGlobalData: state => state.formsModalGlobalData,
        loadFormModalContainerInit: state => state.formModalContainerInit,
        loadFormsModalRealEstate: state => state.formsModalRealEstate,
        // News Items
        loadNewsItemsHome: state => state.newsItemsPromo,
        loadNewsItems: state => state.newsItems,
        loadNewsPaginTotalPage: state => state.newsPaginTotalPage,
        loadNewsPaginCurPage: state => state.newsPaginCurPage,
        // Sales Items
        loadSalesItems: state => state.salesItems,
        loadSalesItemsDefault : state => state.salesItemsDefault,
        loadSalesItemsAnimate: state => state.salesItemsAnimate,
        // Project Getters
        loadOpenSendwich: state => state.isOpenSendwich,
        loadOpenFormConsult: state => state.isOpenFormConsult,
        loadIsMobileChecker: state => state.isMobileChecker,
        loadIsVisibleScrollEvent: state => state.isVisibleOnScrollEvent,
        loadIsHeaderBGscrollEvent: state => state.isHeaderBGonScrollEvent,
        loadIsOpenSalesCardVideoModal: state => state.isSalesCardVideoModalOpen,
        loadSalesCardVideoModalData: state => state.salesCardVideoModalData,
        //
        // FILTERS PARAMS FROM CMS
        loadFilterCMSparams: state => state.filterCMSparams,
        //--//--//--//--// SALES FILTER GETTER
        loadFilterSalesData: state => state.filterSales_Data,
        loadOpenMobileFilter: state => state.openMobileFilter,
        //--//--//--//--// PARKING FILTER GETTER
        loadFilterParkingData: state => state.filterParking_Data,
        loadParkingItems: state => state.parkingItems,
        loadParkingItemsDefault : state => state.parkingItemsDefault,
        loadParkingItemsAnimate: state => state.parkingItemsAnimate,
        loadOpenParkingMobileFilter: state => state.openParkingMobileFilter,
        loadParkingListView: state => state.parkingListView,
        loadParkingShortingParams: state => state.parking_shorting_param,
        loadOpenParkingMobileShorting: state => state.openParkingMobileShorting,
        //--//--//--//--// STOREROOMS FILTER GETTER
        loadFilterStoreRoomsData: state => state.filterStoreRooms_Data,
        loadStoreRoomsItems: state => state.storeRoomsItems,
        loadStoreRoomsItemsDefault : state => state.storeRoomsItemsDefault,
        loadStoreRoomsItemsAnimate: state => state.storeRoomsItemsAnimate,
        loadOpenStoreRoomsMobileFilter: state => state.openStoreRoomsMobileFilter,
        loadStoreRoomsListView: state => state.storeRoomsListView,
        loadStoreRoomsShortingParams: state => state.storeRooms_shorting_param,
        loadOpenStoreRoomsMobileShorting: state => state.openStoreRoomsMobileShorting,
        //--//--//--//--// COMMERCE FILTER GETTER
        loadFilterCommerceData: state => state.filterCommerce_Data,
        loadCommerceItems: state => state.commerceItems,
        loadCommerceItemsDefault : state => state.commerceItemsDefault,
        loadCommerceItemsAnimate: state => state.commerceItemsAnimate,
        loadOpenCommerceMobileFilter: state => state.openCommerceMobileFilter,
        loadOpenCommerceMobileShorting: state => state.openCommerceMobileShorting,
        loadCommerceListView: state => state.commerceListView,
        loadCommerceShortingParams: state => state.commerce_shorting_param,
        //--//--//--//--// FLATS FILTER GETTER
        loadFilterFlatsData: state => state.filterFlats_Data,
        loadFlatsItems: state => state.flatsItems,
        loadFlatsItemsDefault : state => state.flatsItemsDefault,
        loadFlatsItemsAnimate: state => state.flatsItemsAnimate,
        loadOpenFlatsMobileFilter: state => state.openFlatsMobileFilter,
        loadFlatsListView: state => state.flatsListView,
        loadFlatsShortingParams: state => state.flats_shorting_param,
        loadOpenFlatsMobileShorting: state => state.openFlatsMobileShorting,
        loadFlatsResizeElemInit: state => state.flatsResizeElem,
        loadFlatsResizeImg: state => state.flatsResizeImg,
    },
    actions: {
        getFullSetUpProject({commit}) {
            if (this.state.pageSetup == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'section').then(async (response) => {
                        // console.log(response.data[1].acf, 'forms data setup');
                        // commit('setBanerSystem', response.data[0].acf);
                        commit('PageSetUp', response.data[0].acf);
                        commit('formsData', response.data[1].acf);
                        resolve('complete');
                    });
                });
            }
        },
        getIndexPageData({commit}) {
            if (this.state.indexPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/417').then(async (response) => {
                        // console.log(response.data.acf, 'index page');
                        commit('indexPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getAboutPageData({commit}) {
            if (this.state.aboutPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1084').then(async (response) => {
                        // console.log(response.data.acf, 'about page');
                        commit('aboutPageSet', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getPaymentPageData({commit}) {
            if (this.state.paymentPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/477').then(async (response) => {
                        // console.log(response.data.acf, 'payment page');
                        commit('PaymentPageSet', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getQuestionsPageData({commit}) {
            if (this.state.questionsPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1227').then(async (response) => {
                        // console.log(response.data.acf, 'questions page');
                        commit('QuestionsPageSet', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getContactsPageData({commit}) {
            if (this.state.contactsPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1182').then(async (response) => {
                        // console.log(response.data.acf, 'contacts page');
                        commit('ContactsPageSet', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getDataPolicyPageData({commit}) {
            if (this.state.dataPolicyPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1284').then(async (response) => {
                        // console.log(response.data.acf, 'data-policy page');
                        commit('DataPolicyPageSet', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getFavoritePageData({commit}) {
            if (this.state.favoritePage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1338').then(async (response) => {
                        // console.log(response.data.acf, 'favorite page');
                        commit('FavoritePageSet', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        ////////////// FILTER DEFAULT CMS PARAMS
        getFilterCMSparamsData({commit}) {
            if (this.state.filterCMSparams == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/583').then(async (response) => {
                        // console.log(response.data.acf, 'FILTER CMS PARAMS');
                        commit('FilterCMSparams', response.data.acf);
                        commit('FilterSales_update_base', {name: 'updateAll', data: response.data.acf});
                        commit('FilterParking_update_base', {name: 'updateAll', data: response.data.acf})
                        commit('FilterStoreRooms_update_base', {name: 'updateAll', data: response.data.acf})
                        commit('FilterCommerce_update_base', {name: 'updateAll', data: response.data.acf})
                        commit('FilterFlats_update_base', {name: 'updateAll', data: response.data.acf})
                        resolve('complete');
                    });
                });
            }
        },
        getFlatsItems({commit}) {
            if (this.state.flatsItems == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'flats/?per_page=100').then(async (response) => {
                        // console.log(response.data, 'array flats items')
                        commit('FlatsItemsSet', response.data); // коммит всех квартир
                        resolve('complete');
                    });
                });
            }
        },
        getCommerceItems({commit}) {
            if (this.state.commerceItems == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'commerce/?per_page=100').then(async (response) => {
                        // console.log(response.data, 'array commerce items')
                        commit('CommerceItemsSet', response.data); // коммит всех квартир
                        resolve('complete');
                    });
                });
            }
        },
        getParkingItems({commit}) {
            if (this.state.parkingItems == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'parking/?per_page=100').then(async (response) => {
                        // console.log(response.data, 'array parking items')
                        commit('ParkingItemsSet', response.data); // коммит всех квартир
                        resolve('complete');
                    });
                });
            }
        },
        getStoreRoomsItems({commit}) {
            if (this.state.storeRoomsItems == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'storerooms/?per_page=100').then(async (response) => {
                        // console.log(response.data, 'array storerooms items')
                        commit('StoreRoomsItemsSet', response.data); // коммит всех квартир
                        resolve('complete');
                    });
                });
            }
        },
        ///////////// END DEFAULT FILTER CMS PARAMS
        // otherItems
        getNewsItemsPromoByIDs({commit}, payload) {
            if (this.state.newsItemsPromo == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/news?include=' + payload).then(async (response) => {
                        // console.log(response, 'home news ITEMs');
                        commit('newsItemsPromo', response.data);
                        resolve('complete');
                    });
                });
            }
        },
        // NEWS PAGE NEW V WEB CUSTOM REST API CONTROLLER
        getNewsItemsDefault({commit}) {
            if (this.state.newsItems == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + '/wp-json/vweb/v1/news?per_page=5').then(async (response) => {
                        // console.log(response, 'page news ITEMs');
                        commit('newsItemsSetByFilter', response.data);
                        resolve('complete');
                    });
                });
            }
        },
        getNewsItemsByFilterData({commit}, payload) {
            // console.log(payload, 'asdasdasdasasdas')
            axios.get(window.url + window.GlobalLang + 'wp-json/vweb/v1/news?' + payload + '&per_page=5').then(async (response) => {
                // console.log(response, 'FILTER news ITEMs');
                commit('newsItemsSetByFilter', response.data);
            });
        },
        getNewsItemsPgination({commit}, payload) {
            // console.log(payload, 'PAGINATION NEWS')
            axios.get(window.url + window.GlobalLang + 'wp-json/vweb/v1/news?per_page=5&' + payload).then(async (response) => {
                // console.log(response, 'pagination news ITEMs');
                commit('newsItemsSetByPagination', response.data);
            });
        },
        // END NEWS PAGE CUSTOM VWEB CONTROLLER
        // SALES ITEMS SERVER
        // PAGE SALES CARDS / FLATS
        getSalesItems({commit}) {
            if (this.state.salesItems == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'sales/?per_page=100').then(async (response) => {
                        // console.log(response.data, 'array houses')
                        commit('salesItemsSet', response.data); // коммит всех жилых комплексов
                        resolve('complete');
                    });
                });
            }
        },
    },
    mutations: {
        // server mutations
        PageSetUp(state, setup) {
            state.pageSetup = setup
        },
        indexPage(state, data) {
            state.indexPage = data
        },
        aboutPageSet(state, data) {
            state.aboutPage = data
        },
        PaymentPageSet(state, data) {
            state.paymentPage = data
        },
        QuestionsPageSet(state, data) {
            state.questionsPage = data
        },
        ContactsPageSet(state, data) {
            state.contactsPage = data
        },
        DataPolicyPageSet(state, data) {
            state.dataPolicyPage = data
        },
        FavoritePageSet(state, data) {
            state.favoritePage = data
        },
        FavoriteLocalStorageUpdate(state, data) {
            // console.log(data, '9999 HAHAHA')
            state.favoriteLocalStorageUpdate = data
        },
        formsData(state, data) {
            state.formsData = data
        },
        formGlobalParam_set(state, data) {
            state.formsModalGlobalParam = data
        },
        formGlobalDataModal_set(state, data) {
            state.formsModalGlobalData = data;
        },
        formModalContainerOpen(state, data) {
            state.formModalContainerInit = (Math.random() + 1).toString(36).substring(7);
        },
        formsModalRealEstate_setData(state, data) {
            state.formsModalRealEstate = data;
        },
        // Sales Items
        salesItemsSet(state, data) {
            state.salesItems = [];
            state.salesItemsDefault = [];
            var dataARR = [];
            // console.log(data);
            for (var i = 0; i < data.length; i++) {
                dataARR.push(Object.assign(data[i].acf, {
                    id: data[i].id,
                }));
            }
            state.salesItems = dataARR;
            state.salesItemsDefault = dataARR;
        },
        animateSalesItems(state, data) {
            state.salesItemsAnimate = data
        },
        // News Items
        newsItemsPromo(state, data) {
            var dataARR = [];
            state.newsItemsPromo = [];
            for (var i = 0; i < data.length; i++) {
                dataARR.push(Object.assign(data[i].acf, {
                    'id': data[i].id,
                    'slug': data[i].slug,
                    'date': data[i].date,
                }));
            }
            state.newsItemsPromo = dataARR;
        },
        newsItemsSetByFilter(state, data) {
            state.newsItems = [];
            state.newsPaginTotalPage = data.total_pages;
            state.newsPaginCurPage = parseInt(data.current_page);
            // setTimeout(() => {
                state.newsItems = data.posts;
            // }, 10);
        },
        newsItemsSetByPagination(state, data) {
            state.newsPaginTotalPage = data.total_pages;
            state.newsPaginCurPage = parseInt(data.current_page);
            for (var i = 0; i < data.posts.length; i++) {
                state.newsItems.push(data.posts[i]);
            }
        },
        // PROJECT MUTATIONS
        Open_Sendwich(state, data) {
            state.isOpenSendwich = data
        },
        Open_form_Consult(state, data) {
            state.isOpenFormConsult = data
        },
        setMobileCheckerState(state, data) {
            state.isMobileChecker = data
        },
        setVisibleParamOnScrollEvent(state, data) {
            state.isVisibleOnScrollEvent = data
        },
        setHeaderBGOnScrollEvent(state, data) {
            state.isHeaderBGonScrollEvent = data
        },
        setOpenSalesCardVideoModal(state, data) {
            state.isSalesCardVideoModalOpen = data;
        },
        setSalesCardVideoModalData(state, data) {
            state.salesCardVideoModalData = data
        },
        removePageLoaderImg() {
            var loader = document.getElementById('loader');
            if (loader != undefined) {
                loader.classList.remove("InitLoader");
                setTimeout(()=>{
                    loader.remove();
                },1000);
            }
        },
        ////
        ////
        ///
        //
        /// FILTER DEFAULT CMS PARAMS
        FilterCMSparams(state, data) {
            state.filterCMSparams = data
        },
        //--//--//--//--// SALES FILTER UPDATE DATA BASSE
        FilterSales_update_base(state, payload) {
            // console.log(payload, 'asdasdasdasd')
            if (payload.name == 'updateAll') {
                state.filterSales_Data.size = [parseInt(payload.data.sales_filter.flats_filter_params.size_filter.min_size), parseInt(payload.data.sales_filter.flats_filter_params.size_filter.max_size)]
                state.filterSales_Data.floor = [parseInt(payload.data.sales_filter.flats_filter_params.floor_filter.min_floor), parseInt(payload.data.sales_filter.flats_filter_params.floor_filter.max_floor)]
                state.filterSales_Data.price = [parseInt(payload.data.sales_filter.price_filter_params.price_filter.min_price), parseInt(payload.data.sales_filter.price_filter_params.price_filter.max_price)]
                state.filterSales_Data.initRangeSliders = true
            }
            else if (payload.name == 'location_type') {
                state.filterSales_Data.location_type = payload.data
            } 
            else if (payload.name == 'segment_type') {
                state.filterSales_Data.segment_type = payload.data
            } 
            else if (payload.name == 'finish') {
                state.filterSales_Data.finish = payload.data
            }
            else if (payload.name == 'sizeUpdate') {
                if (payload.param == 'min') {
                    state.filterSales_Data.size = [payload.data,  state.filterSales_Data.size[1]]
                } else if (payload.param == 'min_max') {
                    state.filterSales_Data.size = [payload.data,  state.filterSales_Data.size[1]]
                } else if (payload.param == 'max') {
                    state.filterSales_Data.size = [state.filterSales_Data.size[0],  payload.data]
                } else if (payload.param == 'max_max') {
                    state.filterSales_Data.size = [state.filterSales_Data.size[0],  payload.data]
                }
            } else if (payload.name == 'floorUpdate') {
                if (payload.param == 'min') {
                    state.filterSales_Data.floor = [payload.data,  state.filterSales_Data.floor[1]]
                } else if (payload.param == 'min_max') {
                    state.filterSales_Data.floor = [payload.data,  state.filterSales_Data.floor[1]]
                } else if (payload.param == 'max') {
                    state.filterSales_Data.floor = [state.filterSales_Data.floor[0],  payload.data]
                } else if (payload.param == 'max_max') {
                    state.filterSales_Data.floor = [state.filterSales_Data.floor[0],  payload.data]
                }
            } else if (payload.name == 'priceUpdate') {
                if (payload.param == 'min') {
                    state.filterSales_Data.price = [payload.data,  state.filterSales_Data.price[1]]
                } else if (payload.param == 'min_max') {
                    state.filterSales_Data.price = [payload.data,  state.filterSales_Data.price[1]]
                } else if (payload.param == 'max') {
                    state.filterSales_Data.price = [state.filterSales_Data.price[0],  payload.data]
                } else if (payload.param == 'max_max') {
                    state.filterSales_Data.price = [state.filterSales_Data.price[0],  payload.data]
                }
            } else if (payload.name == 'counter') {
                state.filterSales_Data.filter_items_count = payload.data
            } else if (payload.name == 'availableForSales') {
                state.filterSales_Data.availableForSale = payload.data
            } else if (payload.name == 'unAvailableForSaleReset') {
                state.filterSales_Data.unAvailableForSaleReset = payload.data
            }
        },
        /// END FILTER DEFAULT CMS PARAMS
        // FILTER ITEMS 
        FilterSales_Items(state, data) {

        },
        updateSalesItems_filter(state, data) {
            state.salesItems = [];
            state.salesItems = data;
            setTimeout(() => {
                state.salesItemsAnimate = true
            }, 50);
        },
        ReloadFilter(state, data) {
            state.filterSales_Data.location_type = 'district'
            state.filterSales_Data.segment_type = 'all'
            state.filterSales_Data.disctrictChecked = []
            state.filterSales_Data.metroChecked = []
            state.filterSales_Data.roomQuantities = []

            state.filterSales_Data.size = [parseInt(state.filterCMSparams.sales_filter.flats_filter_params.size_filter.min_size), parseInt(state.filterCMSparams.sales_filter.flats_filter_params.size_filter.max_size)]
            state.filterSales_Data.floor = [parseInt(state.filterCMSparams.sales_filter.flats_filter_params.floor_filter.min_floor), parseInt(state.filterCMSparams.sales_filter.flats_filter_params.floor_filter.max_floor)]
            state.filterSales_Data.price = [parseInt(state.filterCMSparams.sales_filter.price_filter_params.price_filter.min_price), parseInt(state.filterCMSparams.sales_filter.price_filter_params.price_filter.max_price)]
            
            state.filterSales_Data.finish = 'not'
            state.filterSales_Data.actions = false
            state.filterSales_Data.unAvailableForSaleReset = false
        },
        OpenMobileFilter(state, data) {
            state.openMobileFilter = data
        },
        //
        //
        //
        //--//--//--//--// PARKING FILTER UPDATE DATA BASSE
        FilterParking_update_base(state, payload) {
            // console.log(payload, 'asdasdasdasd')
            if (payload.name == 'updateAll') {
                state.filterParking_Data.size = [parseInt(payload.data.parking_filter.size.min), parseInt(payload.data.parking_filter.size.max)]
                state.filterParking_Data.price = [parseInt(payload.data.parking_filter.price.min), parseInt(payload.data.parking_filter.price.max)]
                state.filterParking_Data.initRangeSliders = true
            }
            else if (payload.name == 'sizeUpdate') {
                if (payload.param == 'min') {
                    state.filterParking_Data.size = [payload.data,  state.filterParking_Data.size[1]]
                } else if (payload.param == 'min_max') {
                    state.filterParking_Data.size = [payload.data,  state.filterParking_Data.size[1]]
                } else if (payload.param == 'max') {
                    state.filterParking_Data.size = [state.filterParking_Data.size[0],  payload.data]
                } else if (payload.param == 'max_max') {
                    state.filterParking_Data.size = [state.filterParking_Data.size[0],  payload.data]
                } else if (payload.param == 'rangeSlider') {
                    state.filterParking_Data.size = [payload.data.min, payload.data.max]
                }
            }
            else if (payload.name == 'priceUpdate') {
                if (payload.param == 'min') {
                    state.filterParking_Data.price = [payload.data,  state.filterParking_Data.price[1]]
                } else if (payload.param == 'min_max') {
                    state.filterParking_Data.price = [payload.data,  state.filterParking_Data.price[1]]
                } else if (payload.param == 'max') {
                    state.filterParking_Data.price = [state.filterParking_Data.price[0],  payload.data]
                } else if (payload.param == 'max_max') {
                    state.filterParking_Data.price = [state.filterParking_Data.price[0],  payload.data]
                } else if (payload.param == 'rangeSlider') {
                    state.filterParking_Data.price = [payload.data.min, payload.data.max]
                }
            }
        },
        ReloadParkingFilter(state, data) {
            state.filterParking_Data.complexChecked = []
            state.filterParking_Data.partsChecked = []
            state.filterParking_Data.classChecked = []
            state.filterParking_Data.levelQuantities = []

            state.filterParking_Data.size = [parseInt(state.filterCMSparams.parking_filter.size.min), parseInt(state.filterCMSparams.parking_filter.size.max)]
            state.filterParking_Data.price = [parseInt(state.filterCMSparams.parking_filter.price.min), parseInt(state.filterCMSparams.parking_filter.price.max)]
            
            state.filterParking_Data.electro = false
            state.filterParking_Data.actions = false
        },
        OpenParkingMobileFilter(state, data) {
            state.openParkingMobileFilter = data
        },
        OpenParkingMobileShorting(state, data) {
            state.openParkingMobileShorting = data
        },
        ParkingItemsSet(state, data) {
            state.parkingItems = [];
            state.parkingItemsDefault = [];
            var dataARR = [];
            // console.log(data);
            for (var i = 0; i < data.length; i++) {
                dataARR.push(Object.assign(data[i].acf, {
                    id: data[i].id,
                }));
            }
            state.parkingItems = dataARR;
            state.parkingItemsDefault = dataARR;
        },
        animateParkingItems(state, data) {
            state.parkingItemsAnimate = data
        },
        changeParkingListView(state, data) {
            state.parkingListView = data
        },
        setParkingShortingParams(state, data) {
            state.parking_shorting_param = data
        },
        setParkingItemsByShorting(state, payload) {
            // console.log(payload, '12312312312');
            state.filterParking_Data.filter_items_count = payload.items.length;
            if (payload.shorting_params.key == 'price' && payload.shorting_params.type == 'ascending') {
                state.parkingItems = payload.items.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
            } else if (payload.shorting_params.key == 'price' && payload.shorting_params.type == 'descending') {
                state.parkingItems = payload.items.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
            } else if (payload.shorting_params.key == 'level' && payload.shorting_params.type == 'ascending') {
                state.parkingItems = payload.items.sort((a, b) => a.level - b.level);
            } else if (payload.shorting_params.key == 'level' && payload.shorting_params.type == 'descending') {
                state.parkingItems = payload.items.sort((a, b) => b.level - a.level);
            } else if (payload.shorting_params.key == 'size' && payload.shorting_params.type == 'ascending') {
                state.parkingItems = payload.items.sort((a, b) => a.size - b.size);
            } else if (payload.shorting_params.key == 'size' && payload.shorting_params.type == 'descending') {
                state.parkingItems = payload.items.sort((a, b) => b.size - a.size);
            }
        },
        /// END FILTER DEFAULT CMS PARAMS PARKING
        //--//--//--//--// STOREROOMS FILTER UPDATE DATA BASSE
        FilterStoreRooms_update_base(state, payload) {
            // console.log(payload, 'asdasdasdasd')
            if (payload.name == 'updateAll') {
                state.filterStoreRooms_Data.size = [parseInt(payload.data.storerooms_filter.size.min), parseInt(payload.data.storerooms_filter.size.max)]
                state.filterStoreRooms_Data.price = [parseInt(payload.data.storerooms_filter.price.min), parseInt(payload.data.storerooms_filter.price.max)]
                state.filterStoreRooms_Data.initRangeSliders = true
            }
            else if (payload.name == 'sizeUpdate') {
                if (payload.param == 'min') {
                    state.filterStoreRooms_Data.size = [payload.data,  state.filterStoreRooms_Data.size[1]]
                } else if (payload.param == 'min_max') {
                    state.filterStoreRooms_Data.size = [payload.data,  state.filterStoreRooms_Data.size[1]]
                } else if (payload.param == 'max') {
                    state.filterStoreRooms_Data.size = [state.filterStoreRooms_Data.size[0],  payload.data]
                } else if (payload.param == 'max_max') {
                    state.filterStoreRooms_Data.size = [state.filterStoreRooms_Data.size[0],  payload.data]
                } else if (payload.param == 'rangeSlider') {
                    state.filterStoreRooms_Data.size = [payload.data.min, payload.data.max]
                }
            }
            else if (payload.name == 'priceUpdate') {
                if (payload.param == 'min') {
                    state.filterStoreRooms_Data.price = [payload.data,  state.filterStoreRooms_Data.price[1]]
                } else if (payload.param == 'min_max') {
                    state.filterStoreRooms_Data.price = [payload.data,  state.filterStoreRooms_Data.price[1]]
                } else if (payload.param == 'max') {
                    state.filterStoreRooms_Data.price = [state.filterStoreRooms_Data.price[0],  payload.data]
                } else if (payload.param == 'max_max') {
                    state.filterStoreRooms_Data.price = [state.filterStoreRooms_Data.price[0],  payload.data]
                } else if (payload.param == 'rangeSlider') {
                    state.filterStoreRooms_Data.price = [payload.data.min, payload.data.max]
                }
            }
        },
        ReloadStoreRoomsFilter(state, data) {
            state.filterStoreRooms_Data.complexChecked = []
            state.filterStoreRooms_Data.partsChecked = []
            state.filterStoreRooms_Data.classChecked = []
            state.filterStoreRooms_Data.levelQuantities = []

            state.filterStoreRooms_Data.size = [parseInt(state.filterCMSparams.storerooms_filter.size.min), parseInt(state.filterCMSparams.storerooms_filter.size.max)]
            state.filterStoreRooms_Data.price = [parseInt(state.filterCMSparams.storerooms_filter.price.min), parseInt(state.filterCMSparams.storerooms_filter.price.max)]
            
            state.filterStoreRooms_Data.actions = false
        },
        OpenStoreRoomsMobileFilter(state, data) {
            state.openStoreRoomsMobileFilter = data
        },
        OpenStoreRoomsMobileShorting(state, data) {
            state.openStoreRoomsMobileShorting = data
        },
        StoreRoomsItemsSet(state, data) {
            state.storeRoomsItems = [];
            state.storeRoomsItemsDefault = [];
            var dataARR = [];
            // console.log(data);
            for (var i = 0; i < data.length; i++) {
                dataARR.push(Object.assign(data[i].acf, {
                    id: data[i].id,
                }));
            }
            state.storeRoomsItems = dataARR;
            state.storeRoomsItemsDefault = dataARR;
        },
        animateStoreRoomsItems(state, data) {
            state.storeRoomsItemsAnimate = data
        },
        changeStoreRoomsListView(state, data) {
            state.storeRoomsListView = data
        },
        setStoreRoomsShortingParams(state, data) {
            state.storeRooms_shorting_param = data
        },
        setStoreRoomsItemsByShorting(state, payload) {
            state.filterStoreRooms_Data.filter_items_count = payload.items.length;
            if (payload.shorting_params.key == 'price' && payload.shorting_params.type == 'ascending') {
                state.storeRoomsItems = payload.items.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
            } else if (payload.shorting_params.key == 'price' && payload.shorting_params.type == 'descending') {
                state.storeRoomsItems = payload.items.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
            } else if (payload.shorting_params.key == 'level' && payload.shorting_params.type == 'ascending') {
                state.storeRoomsItems = payload.items.sort((a, b) => a.level - b.level);
            } else if (payload.shorting_params.key == 'level' && payload.shorting_params.type == 'descending') {
                state.storeRoomsItems = payload.items.sort((a, b) => b.level - a.level);
            } else if (payload.shorting_params.key == 'size' && payload.shorting_params.type == 'ascending') {
                state.storeRoomsItems = payload.items.sort((a, b) => a.size - b.size);
            } else if (payload.shorting_params.key == 'size' && payload.shorting_params.type == 'descending') {
                state.storeRoomsItems = payload.items.sort((a, b) => b.size - a.size);
            }
        },
        /// END FILTER DEFAULT CMS PARAMS STOREROOMS
        //--//--//--//--// COMMERCE FILTER UPDATE DATA BASSE
        FilterCommerce_update_base(state, payload) {
            // console.log(payload, 'asdasdasdasd')
            if (payload.name == 'updateAll') {
                state.filterCommerce_Data.size = [parseInt(payload.data.commerce_filter.size.min), parseInt(payload.data.commerce_filter.size.max)]
                state.filterCommerce_Data.price = [parseInt(payload.data.commerce_filter.price.min), parseInt(payload.data.commerce_filter.price.max)]
                state.filterCommerce_Data.level = [parseInt(payload.data.commerce_filter.level.min), parseInt(payload.data.commerce_filter.level.max)]
                state.filterCommerce_Data.initRangeSliders = true
            }
            else if (payload.name == 'sizeUpdate') {
                if (payload.param == 'min') {
                    state.filterCommerce_Data.size = [payload.data,  state.filterCommerce_Data.size[1]]
                } else if (payload.param == 'min_max') {
                    state.filterCommerce_Data.size = [payload.data,  state.filterCommerce_Data.size[1]]
                } else if (payload.param == 'max') {
                    state.filterCommerce_Data.size = [state.filterCommerce_Data.size[0],  payload.data]
                } else if (payload.param == 'max_max') {
                    state.filterCommerce_Data.size = [state.filterCommerce_Data.size[0],  payload.data]
                } else if (payload.param == 'rangeSlider') {
                    state.filterCommerce_Data.size = [payload.data.min, payload.data.max]
                }
            }
            else if (payload.name == 'priceUpdate') {
                if (payload.param == 'min') {
                    state.filterCommerce_Data.price = [payload.data,  state.filterCommerce_Data.price[1]]
                } else if (payload.param == 'min_max') {
                    state.filterCommerce_Data.price = [payload.data,  state.filterCommerce_Data.price[1]]
                } else if (payload.param == 'max') {
                    state.filterCommerce_Data.price = [state.filterCommerce_Data.price[0],  payload.data]
                } else if (payload.param == 'max_max') {
                    state.filterCommerce_Data.price = [state.filterCommerce_Data.price[0],  payload.data]
                } else if (payload.param == 'rangeSlider') {
                    state.filterCommerce_Data.price = [payload.data.min, payload.data.max]
                }
            }
            else if (payload.name == 'levelUpdate') {
                if (payload.param == 'min') {
                    state.filterCommerce_Data.level = [payload.data,  state.filterCommerce_Data.level[1]]
                } else if (payload.param == 'min_max') {
                    state.filterCommerce_Data.level = [payload.data,  state.filterCommerce_Data.level[1]]
                } else if (payload.param == 'max') {
                    state.filterCommerce_Data.level = [state.filterCommerce_Data.level[0],  payload.data]
                } else if (payload.param == 'max_max') {
                    state.filterCommerce_Data.level = [state.filterCommerce_Data.level[0],  payload.data]
                } else if (payload.param == 'rangeSlider') {
                    state.filterCommerce_Data.level = [payload.data.min, payload.data.max]
                }
            }
        },
        ReloadCommerceFilter(state, data) {
            state.filterCommerce_Data.complexChecked = []
            state.filterCommerce_Data.partsChecked = []
            state.filterCommerce_Data.classChecked = []
            state.filterCommerce_Data.levelQuantities = []

            state.filterCommerce_Data.size = [parseInt(state.filterCMSparams.commerce_filter.size.min), parseInt(state.filterCMSparams.commerce_filter.size.max)]
            state.filterCommerce_Data.price = [parseInt(state.filterCMSparams.commerce_filter.price.min), parseInt(state.filterCMSparams.commerce_filter.price.max)]
            
            state.filterCommerce_Data.actions = false
        },
        OpenCommerceMobileFilter(state, data) {
            state.openCommerceMobileFilter = data
        },
        OpenCommerceMobileShorting(state, data) {
            state.openCommerceMobileShorting = data
        },
        CommerceItemsSet(state, data) {
            state.commerceItems = [];
            state.commerceItemsDefault = [];
            var dataARR = [];
            // console.log(data);
            for (var i = 0; i < data.length; i++) {
                dataARR.push(Object.assign(data[i].acf, {
                    id: data[i].id,
                }));
            }
            state.commerceItems = dataARR;
            state.commerceItemsDefault = dataARR;
        },
        animateCommerceItems(state, data) {
            state.commerceItemsAnimate = data
        },
        changeCommerceListView(state, data) {
            state.commerceListView = data
        },
        setCommerceShortingParams(state, data) {
            state.commerce_shorting_param = data
        },
        setCommerceItemsByShorting(state, payload) {
            state.filterCommerce_Data.filter_items_count = payload.items.length;
            if (payload.shorting_params.key == 'price' && payload.shorting_params.type == 'ascending') {
                state.commerceItems = payload.items.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
            } else if (payload.shorting_params.key == 'price' && payload.shorting_params.type == 'descending') {
                state.commerceItems = payload.items.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
            } else if (payload.shorting_params.key == 'level' && payload.shorting_params.type == 'ascending') {
                state.commerceItems = payload.items.sort((a, b) => a.level - b.level);
            } else if (payload.shorting_params.key == 'level' && payload.shorting_params.type == 'descending') {
                state.commerceItems = payload.items.sort((a, b) => b.level - a.level);
            } else if (payload.shorting_params.key == 'size' && payload.shorting_params.type == 'ascending') {
                state.commerceItems = payload.items.sort((a, b) => a.size - b.size);
            } else if (payload.shorting_params.key == 'size' && payload.shorting_params.type == 'descending') {
                state.commerceItems = payload.items.sort((a, b) => b.size - a.size);
            }
        },
        /// END FILTER DEFAULT CMS PARAMS COMMERCE
        //--//--//--//--// FLATS FILTER UPDATE DATA BASSE
        FilterFlats_update_base(state, payload) {
            // console.log(payload, 'asdasdasdasd')
            if (payload.name == 'updateAll') {
                state.filterFlats_Data.size = [parseInt(payload.data.flats_filter.size.min), parseInt(payload.data.flats_filter.size.max)]
                state.filterFlats_Data.floor = [parseInt(payload.data.flats_filter.floor.min), parseInt(payload.data.flats_filter.floor.max)]
                state.filterFlats_Data.price = [parseInt(payload.data.flats_filter.price.min), parseInt(payload.data.flats_filter.price.max)]
                state.filterFlats_Data.initRangeSliders = true
            }
            else if (payload.name == 'segment_type') {
                state.filterFlats_Data.segment_type = payload.data
            } 
            else if (payload.name == 'sizeUpdate') {
                if (payload.param == 'min') {
                    state.filterFlats_Data.size = [payload.data,  state.filterFlats_Data.size[1]]
                } else if (payload.param == 'min_max') {
                    state.filterFlats_Data.size = [payload.data,  state.filterFlats_Data.size[1]]
                } else if (payload.param == 'max') {
                    state.filterFlats_Data.size = [state.filterFlats_Data.size[0],  payload.data]
                } else if (payload.param == 'max_max') {
                    state.filterFlats_Data.size = [state.filterFlats_Data.size[0],  payload.data]
                } else if (payload.param == 'rangeSlider') {
                    state.filterFlats_Data.size = [payload.data.min, payload.data.max]
                }
            }
            else if (payload.name == 'floorUpdate') {
                if (payload.param == 'min') {
                    state.filterFlats_Data.floor = [payload.data,  state.filterFlats_Data.floor[1]]
                } else if (payload.param == 'min_max') {
                    state.filterFlats_Data.floor = [payload.data,  state.filterFlats_Data.floor[1]]
                } else if (payload.param == 'max') {
                    state.filterFlats_Data.floor = [state.filterFlats_Data.floor[0],  payload.data]
                } else if (payload.param == 'max_max') {
                    state.filterFlats_Data.floor = [state.filterFlats_Data.floor[0],  payload.data]
                } else if (payload.param == 'rangeSlider') {
                    state.filterFlats_Data.floor = [payload.data.min, payload.data.max]
                }
            }
            else if (payload.name == 'priceUpdate') {
                if (payload.param == 'min') {
                    state.filterFlats_Data.price = [payload.data,  state.filterFlats_Data.price[1]]
                } else if (payload.param == 'min_max') {
                    state.filterFlats_Data.price = [payload.data,  state.filterFlats_Data.price[1]]
                } else if (payload.param == 'max') {
                    state.filterFlats_Data.price = [state.filterFlats_Data.price[0],  payload.data]
                } else if (payload.param == 'max_max') {
                    state.filterFlats_Data.price = [state.filterFlats_Data.price[0],  payload.data]
                } else if (payload.param == 'rangeSlider') {
                    state.filterFlats_Data.price = [payload.data.min, payload.data.max]
                }
            }
        },
        ReloadFlatsFilter(state, data) {
            state.filterFlats_Data.segment_type = 'all'
            state.filterFlats_Data.complexChecked = []
            state.filterFlats_Data.partsChecked = []
            state.filterFlats_Data.roomsQuantities = []

            state.filterFlats_Data.size = [parseInt(state.filterCMSparams.flats_filter.size.min), parseInt(state.filterCMSparams.flats_filter.size.max)]
            state.filterFlats_Data.floor = [parseInt(state.filterCMSparams.flats_filter.floor.min), parseInt(state.filterCMSparams.flats_filter.floor.max)]
            state.filterFlats_Data.price = [parseInt(state.filterCMSparams.flats_filter.price.min), parseInt(state.filterCMSparams.flats_filter.price.max)]
            
            state.filterFlats_Data.actions = false
        },
        OpenFlatsMobileFilter(state, data) {
            state.openFlatsMobileFilter = data
        },
        OpenFlatsMobileShorting(state, data) {
            state.openFlatsMobileShorting = data
        },
        FlatsItemsSet(state, data) {
            state.flatsItems = [];
            state.flatsItemsDefault = [];
            var dataARR = [];
            // console.log(data);
            for (var i = 0; i < data.length; i++) {
                dataARR.push(Object.assign(data[i].acf, {
                    id: data[i].id,
                }));
            }
            state.flatsItems = dataARR;
            state.flatsItemsDefault = dataARR;
        },
        animateFlatsItems(state, data) {
            state.flatsItemsAnimate = data
        },
        changeFlatsListView(state, data) {
            state.flatsListView = data
        },
        setFlatsShortingParams(state, data) {
            state.flats_shorting_param = data
        },
        setFlatsItemsByShorting(state, payload) {
            state.filterFlats_Data.filter_items_count = payload.items.length;
            if (payload.shorting_params.key == 'price' && payload.shorting_params.type == 'ascending') {
                state.flatsItems = payload.items.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
            } else if (payload.shorting_params.key == 'price' && payload.shorting_params.type == 'descending') {
                state.flatsItems = payload.items.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
            } else if (payload.shorting_params.key == 'room' && payload.shorting_params.type == 'ascending') {
                state.flatsItems = payload.items.sort((a, b) => a.rooms.value - b.rooms.value);
            } else if (payload.shorting_params.key == 'room' && payload.shorting_params.type == 'descending') {
                state.flatsItems = payload.items.sort((a, b) => b.rooms.value - a.rooms.value);
            } else if (payload.shorting_params.key == 'size' && payload.shorting_params.type == 'ascending') {
                state.flatsItems = payload.items.sort((a, b) => a.size - b.size);
            } else if (payload.shorting_params.key == 'size' && payload.shorting_params.type == 'descending') {
                state.flatsItems = payload.items.sort((a, b) => b.size - a.size);
            }
        },
        /// END FILTER DEFAULT CMS PARAMS FLATS
        flatsResizeElemInit(state, data) {
            state.flatsResizeElem = data
        },
        flatsResizeImgSet(state, data) {
            state.flatsResizeImg = data
        }
    }
})